import useFetchWrapper, { HttpResponse } from '../../Helpers/useFetchWrapper';
import { useEffect, useState } from 'react';
import { FeedBackDetails, FeedbackTypes, User } from './BackofficeFeedbackDetails.model';
import {FeedbackState} from "../BackofficeFeedbackList/SpamTab/SpamTab.model";
import {useHistory} from "react-router";

const useBackofficeFeedbackDetails = (props: { id: string }) => {
	const { id } = props;
	const { get, put } = useFetchWrapper();
	const history = useHistory();


	const [feedbackDetails, setFeedbackDetails] = useState<FeedBackDetails>();
	const [reply, setReply] = useState<boolean>(false);
	const [admins, setAdmins] = useState<User[]>();
	const [imageHover, setImageHover] = useState(false);
	const [openPopup, setOpenPopup] = useState<boolean>(false);
	
	useEffect(() => {
		getFeedbackDetails();
	}, [id]);

	useEffect(() => {
		getAdmins();
	}, []);

	const getFeedbackDetails = async () => {
		const feedbackDetails: HttpResponse<FeedBackDetails> = await get(
			`/review/feedback/${id}`
		);
		setFeedbackDetails(feedbackDetails.parsedBody);
	};

	const resolveFeedback = async () => {
		const response = await put(
			`/review/feedback-resolve/${feedbackDetails?.id}`,
			"Completed"
		);
		if (response.status === 200) getFeedbackDetails();
	};

	const activateFeedback = async () => {
		const response = await put(`/review/feedback-state/${feedbackDetails?.id}`, FeedbackState.Active);
		if (response.status === 200) getFeedbackDetails();
	};
	
	const sendToSpam = async () => {
		const response = await put(`/review/feedback-state/${feedbackDetails?.id}`, FeedbackState.Spam);
		if (response.status === 200) getFeedbackDetails();
	};
	
	const archiveFeedback = async () => {
		const response = await put(`/review/feedback-state/${feedbackDetails?.id}`, FeedbackState.Archived);
		if (response.status === 200) getFeedbackDetails();
	}

	const assignFeedback = async (userId: string) => {
		const response = await put(
			`/review/feedback-assign/${feedbackDetails?.id}`,
			{ userId }
		);
		if (response.status === 200) getFeedbackDetails();
	};

	const reassignFeedback = async (userId: string) => {
		const response = await put(
			`/review/feedback-reassign/${feedbackDetails?.id}`,
			{ userId }
		);
		if (response.status === 200) getFeedbackDetails();
	};

	const feedbackReply = async (message: string) => {
		const response = await put(
			`/review/feedback-reply/${id}`,
			message
		);
		if (response.status === 200) getFeedbackDetails();
	};

	const getAdmins = async () => {
		const response: HttpResponse<{ count: number; users: User[] }> = await get(
			`/user/admin?page=${1}&size=${100}`
		);
		if (response.parsedBody) {
			const { users } = response.parsedBody;
			setAdmins(users);
		}
	};

	const isVideoFeedback = () => {
		return feedbackDetails?.feedbackType === FeedbackTypes.VideoFeedback;
	}

	const toggleReply = () => {
		setReply((prevState) => !prevState);
	};
	
	const toggleImageHover = () => {
		setImageHover((prevState) => !prevState);
	};
	
	const togglePopup = () => {
		setOpenPopup((prevState) => !prevState);
	};
	
	const navigateTo = (path: string) => {
		history.push(path);
	}

	const isAssignedAdminDeleted = (adminId: string) => {
		return !admins?.find(admin => admin.userId === adminId);
	}

	return {
		activateFeedback,
		archiveFeedback,
		assignFeedback,
		feedbackReply,
		isAssignedAdminDeleted,
		isVideoFeedback,
		navigateTo,
		reassignFeedback,
		resolveFeedback,
		sendToSpam,
		state: {
			admins,
			feedback: { ...feedbackDetails },
			imageHover,
			openPopup,
			reply,
		},
		toggleImageHover,
		togglePopup,
		toggleReply,
	};
};
export default useBackofficeFeedbackDetails;